import { useSEO } from "@/hooks/useSEO";
import { SeoPageLayout } from "@/components/seo/SeoPageLayout";
import { SeoSection, SeoSubSection, SeoList } from "@/components/seo/SeoContent";
import { AccompanimentInlineDialog } from "@/components/seo/AccompanimentInlineDialog";


const SITE = "https://www.regard-de-nature.fr";

const TdahDysEnfants = () => {
  useSEO({
    title: "Naturopathie TDAH, DYS & enfants atypiques – Regard de Nature",
    description:
      "Accompagnement naturopathique des enfants TDAH, hypersensibles ou DYS : sommeil, alimentation, émotions, concentration. Bilan personnalisé par Laura Elie.",
    canonical: `${SITE}/tdah-dys-enfants-atypiques`,
  });

  return (
    <SeoPageLayout
      h1="TDAH, DYS & enfants atypiques"
      intro="Accompagner les troubles de l'attention, l'hypersensibilité, les troubles DYS et les émotions de l'enfant, avec une approche naturelle, globale et bienveillante."
    >
      <SeoSection title="Accompagnement des enfants atypiques">
        <p>
          Votre enfant présente un TDAH, des troubles de l'attention, une hyperactivité, une hypersensibilité
          émotionnelle ou des troubles DYS comme la dyslexie, la dyspraxie ou la dysorthographie ?
        </p>
        <p>
          Vous observez des difficultés de concentration, des colères fréquentes, une impulsivité importante, des
          troubles du sommeil, une fatigue récurrente ou des difficultés dans la gestion des émotions ?
        </p>
        <p>
          La naturopathie propose une approche globale permettant d'explorer les différents facteurs pouvant
          influencer le bien-être de votre enfant : alimentation, sommeil, digestion, gestion des émotions,
          équilibre nerveux, activité physique et hygiène de vie.
        </p>
        <p>
          En soutenant l'équilibre global de l'organisme, la naturopathie peut contribuer à améliorer le bien-être
          de l'enfant, mais également avoir un impact positif sur son comportement au quotidien, sa capacité de
          concentration, sa gestion émotionnelle, son niveau d'énergie et sa qualité de sommeil.
        </p>
        <p>
          Lors du bilan naturopathique enfant, nous prenons le temps d'étudier son fonctionnement dans sa globalité
          afin de construire un accompagnement personnalisé, adapté à ses besoins, à son âge et à son quotidien.
        </p>
        <p>
          👉{" "}
          <AccompanimentInlineDialog
            slug="bilan-naturopathique-enfants-adolescents"
            trigger={
              <button className="text-primary underline hover:text-secondary text-left">
                Découvrir le bilan naturopathique enfant
              </button>
            }
          />
        </p>
      </SeoSection>

      <SeoSection title="Un accompagnement pour les familles d'enfants atypiques">
        <p>
          Être parent d'un enfant TDAH, d'un enfant hypersensible ou d'un enfant DYS peut parfois devenir éprouvant.
        </p>
        <p>
          Les difficultés scolaires, les troubles du sommeil, les émotions débordantes, les rendez-vous médicaux ou
          la charge mentale peuvent impacter l'équilibre de toute la famille.
        </p>
        <p>
          Lorsque les difficultés de l'enfant retentissent également sur le quotidien familial, le{" "}
          <strong>Parcours Famille Courageuse</strong> permet d'accompagner à la fois l'enfant et le parent afin de
          retrouver davantage de sérénité, d'équilibre et d'harmonie familiale.
        </p>
        <SeoSubSection title="Cet accompagnement se déroule sur trois rendez-vous">
          <SeoList
            items={[
              "Un bilan naturopathique enfant avec son Programme d'Hygiène de Vie personnalisé",
              "Un bilan naturopathique adulte avec son Programme d'Hygiène de Vie personnalisé",
              "Une séance de suivi familiale",
            ]}
          />
        </SeoSubSection>
        <p>
          👉{" "}
          <AccompanimentInlineDialog
            slug="parcours-famille-courageuse"
            trigger={
              <button className="text-primary underline hover:text-secondary text-left">
                Découvrir le Parcours Famille Courageuse
              </button>
            }
          />
        </p>
      </SeoSection>

      <SeoSection title="💻 Accompagnement en visio partout en France">
        <p>Les consultations peuvent également être réalisées en visioconférence.</p>
        <p>
          Cette solution est particulièrement appréciée des familles dont le quotidien est déjà bien rempli ou
          lorsque les déplacements sont compliqués à organiser.
        </p>
        <p>
          Où que vous soyez en France, vous pouvez bénéficier d'un accompagnement personnalisé pour votre enfant
          depuis le confort de votre domicile.
        </p>
      </SeoSection>
    </SeoPageLayout>
  );
};

export default TdahDysEnfants;
